/**
 * User actions
 */
export const APPLICATION_UPDATE = 'APPLICATION_UPDATE';

export function applicationUpdate(name, payload) {
    return { type: APPLICATION_UPDATE, name, payload };
};